import React, { Fragment } from 'react';
import { Header, Button, Grid, Segment, Table, Icon, Form, Popup, Message, Label } from 'semantic-ui-react';
import axios from 'axios';
import moment, { now } from 'moment';
import { ToastContainer, toast } from 'react-toastify';

import { DateTimePicker } from 'react-widgets';
import { FiltersOnStyle } from '../../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class AcademicTitles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            person: {},
            employee: {},

            editInfo: false,
            main: null,

            addTitleMode: false,

            editAcademicInfo: false,


            academicTitles: [],
            academicTitle: null,

            documentNumber: null,
            expirationDate: null,
            promotionDate: null,

            optLock: null,
            id: null,

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.addAcademicTitle = this.addAcademicTitle.bind(this);
        this.editTitle = this.editTitle.bind(this);
    }

    componentWillMount() {
        this.setState({
            person: JSON.parse(localStorage.getItem('person')),
            employee: JSON.parse(localStorage.getItem('employee')),
            main: localStorage.getItem('main') === 'true'
        });

        axios.get('academic-titles',)
            .then(res => {
                this.setState({
                    academicTitles: res.data.filter(e => e.abbreviationSuffix !== '').map(el => ({
                        el, text: el.name + (el.abbreviationPrefix !== '' ? ' ( ' + el.abbreviationPrefix + ' )' : ''), key: el.id, value: el.id
                    }))
                });

                if (this.props.edit) {
                    let titles = JSON.parse(localStorage.getItem('employee')).academicTitles[0];
                    this.setState({
                        academicTitle: titles.academicTitle.id,
                        documentNumber: titles.documentNumber,
                        expirationDate: titles.expirationDate,
                        promotionDate: titles.promotionDate,
                        optLock: titles.optLock,
                        id: titles.id
                    });
                }
            })
            .catch(err => {
                console.log('Failed to fetch academic titles.');
            });
    }

    addAcademicTitle() {
        let obj = {
            employee: { id: JSON.parse(localStorage.getItem('employee')).id },
            academicTitle: { id: this.state.academicTitle },
            documentNumber: this.state.documentNumber,
            expirationDate: this.state.expirationDate,
            promotionDate: this.state.promotionDate
        };

        axios.post('employees/academic-titles/', { ...obj })
            .then(res => {
                toast('Dodavanje titule je uspješno izvršeno.');

                let obj = { jmbg: JSON.parse(localStorage.getItem('person')).jmbg };

                axios.post('hr/get-employee-by-jmbg/', { ...obj })
                    .then(re => {
                        localStorage.setItem('employee', JSON.stringify(re.data[0]));
                        re.data[0].associateStaff ? localStorage.setItem('associate', 'true') : localStorage.setItem('associate', 'false');
                        this.setState({
                            employee: re.data[0],
                            addTitleMode: false,
                            academicTitle: null,
                            documentNumber: null,
                            expirationDate: null,
                            promotionDate: null
                        });
                    });
            })
            .catch(err => {
                toast('Došlo je do greške! Dodavanje titule nije usoješno izvršeno.');
            });
    }

    editTitle() {
        let obj = {
            employee: { id: JSON.parse(localStorage.getItem('employee')).id },
            academicTitle: { id: this.state.academicTitle },
            documentNumber: this.state.documentNumber,
            expirationDate: this.state.expirationDate,
            promotionDate: this.state.promotionDate,
            optLock: this.state.optLock,
            id: this.state.id
        };
        axios.put('employees/academic-titles/', { ...obj })
            .then(res => {
                toast('Izmjena titule je uspješno izvršena.');

                let obj = { jmbg: JSON.parse(localStorage.getItem('person')).jmbg };

                axios.post('hr/get-employee-by-jmbg/', { ...obj })
                    .then(re => {
                        localStorage.setItem('employee', JSON.stringify(re.data[0]));
                        re.data[0].associateStaff ? localStorage.setItem('associate', 'true') : localStorage.setItem('associate', 'false');
                        this.setState({
                            employee: re.data[0],
                            editAcademicInfo: false,
                            academicTitle: null,
                            documentNumber: null,
                            expirationDate: null,
                            promotionDate: null
                        });
                    });
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena titule nije uspješno izvršeno.');
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        const {
            employee, person, editAcademicInfo, addTitleMode, main
        } = this.state;
        return (
            <div >
                <Table celled selectable compact >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Titula</Table.HeaderCell>
                            <Table.HeaderCell>Broj odluke</Table.HeaderCell>
                            <Table.HeaderCell>Datum izbora u zvanje</Table.HeaderCell>
                            <Table.HeaderCell>Datum isteka zvanja</Table.HeaderCell>
                            {(main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') &&
                            <Table.HeaderCell as="th" verticalAlign="middle" textAlign="center" width="2">
                                <Popup
                                    content="Dodaj titulu"
                                    position="top center"
                                    trigger={
                                        <Button
                                            icon="add"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            onClick={() => this.setState({ addTitleMode: true })}
                                        />}
                                />
                            </Table.HeaderCell>}
                        </Table.Row>
                    </Table.Header>
                    { (employee.academicTitles && employee.academicTitles.length) || addTitleMode ? <Table.Body>
                        {addTitleMode && <Table.Row >
                            <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Field>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            options={this.state.academicTitles}
                                            onChange={this.handleInputChange}
                                            value={this.state.academicTitle}
                                            name="academicTitle"
                                            placeholder="Odaberite titulu"
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Field>
                                        <input
                                            value={this.state.documentNumber}
                                            onChange={(e) => this.setState({ documentNumber: e.target.value })}
                                            name="documentNumber"
                                            placeholder="Unesite broj odluke"
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form>
                                    <Form.Field>
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'promotionDate')}
                                            value={this.state.promotionDate}
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" >
                                <Form>
                                    <Form.Field>
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'expirationDate')}
                                            value={this.state.expirationDate}
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            {(main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Table.Cell textAlign="center" verticalAlign="middle" >
                                <Button color="blue" circular icon="check" onClick={this.addAcademicTitle} />
                                <Button
                                    color="blue"
                                    basic="true"
                                    circular
                                    icon="close"
                                    onClick={() => this.setState({
                                        addTitleMode: false, academicTitle: null, documentNumber: null, expirationDate: null, promotionDate: null
                                    })}
                                />
                            </Table.Cell>}
                        </Table.Row>}
                        {employee.academicTitles.map((title, index) => (
                            <Table.Row key={index} >
                                <Table.Cell verticalAlign="middle">
                                    {editAcademicInfo === index ?
                                        <Form noValidate>
                                            <Form.Field>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    options={this.state.academicTitles}
                                                    onChange={this.handleInputChange}
                                                    value={this.state.academicTitle}
                                                    name="academicTitle"
                                                    placeholder="Odaberite titulu"
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                        </Form>
                                        : title.academicTitle.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {editAcademicInfo === index ?
                                        <Form noValidate>
                                            <Form.Field>
                                                <input
                                                    value={this.state.documentNumber}
                                                    onChange={(e) => this.setState({ documentNumber: e.target.value })}
                                                    name="documentNumber"
                                                    placeholder="Unesite broj odluke"
                                                />
                                            </Form.Field>
                                        </Form>
                                        : title.documentNumber ? title.documentNumber : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {editAcademicInfo === index ?
                                        <Form noValidate>
                                            <Form.Field>
                                                <DateTimePicker
                                                    format="D. M. YYYY."
                                                    time={false}
                                                    onChange={this.handleDateChange.bind(null, 'promotionDate')}
                                                    value={this.state.promotionDate ? new Date(this.state.promotionDate) : null}
                                                />
                                            </Form.Field>
                                        </Form>
                                        : title.promotionDate ? moment(title.promotionDate).format('D. M. YYYY.') : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" error={moment(title.expirationDate) <= moment(now())}>
                                    {editAcademicInfo === index ?
                                        <Form noValidate>
                                            <Form.Field>
                                                <DateTimePicker
                                                    format="D. M. YYYY."
                                                    time={false}
                                                    onChange={this.handleDateChange.bind(null, 'expirationDate')}
                                                    value={this.state.expirationDate ? new Date(this.state.expirationDate) : null}
                                                />
                                            </Form.Field>
                                        </Form>
                                        : title.expirationDate ? <Fragment>
                                            {moment(title.expirationDate).format('D. M. YYYY.')}
                                            <span style={{ float: 'right' }}> {moment(title.expirationDate) <= moment(now()) && <Label prompt size="mini" color="red" basic> <Icon name="attention" /> Isteklo</Label>}</span>
                                        </Fragment> : ''}
                                </Table.Cell>
                                {(main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && <Table.Cell verticalAlign="middle" textAlign="center">
                                    {editAcademicInfo === index ? <div>
                                        <Button color="blue" circular icon="check" onClick={this.editTitle} />
                                        <Button
                                            color="blue"
                                            basic="true"
                                            circular
                                            icon="close"
                                            onClick={() => this.setState({
                                                editAcademicInfo: false, academicTitle: null, documentNumber: null, expirationDate: null, promotionDate: null
                                            })}
                                        />
                                    </div>
                                        : <Button
                                            onClick={() => this.setState({
                                                editAcademicInfo: index,
                                                academicTitle: title.academicTitle.id,
                                                documentNumber: title.documentNumber,
                                                expirationDate: title.expirationDate,
                                                promotionDate: title.promotionDate,
                                                optLock: title.optLock,
                                                id: title.id
                                            })}
                                            basic="true"
                                            circular
                                            icon="pencil"
                                            size="small"
                                            color="green"
                                        />}
                                </Table.Cell>}
                            </Table.Row>))}
                    </Table.Body> :
                    <Table.Body>
                            <Table.Row>
                            <Table.Cell>
                                    Nema unesenih podataka o zvanjima.
                                </Table.Cell>
                        </Table.Row>
                        </Table.Body>}
                </Table>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/profile/Employee/AcademicTitles.js